//import { SalesforceRoleModel } from "@api/types/salesforcerole";
import { httpClient } from "../../httpClient";

type Data = any;

const maintenanceroleWebApi = "/api/v1/maintenancerole";

export async function get(): Promise<any> {
  try {
    const { data } = await httpClient.get(maintenanceroleWebApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSystemTypeAndCategoryBySystemAppId(
  id: number
): Promise<any> {
  try {
    const { data } = await httpClient.get(
      `${maintenanceroleWebApi}/systemtypeandcategory/bysystemapp/${id}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getRoleApproversByRoleId(id: number): Promise<any> {
  try {
    if (id) {
      const { data } = await httpClient.get(
        `${maintenanceroleWebApi}/approvers/${id}`
      );
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function post(payload: any): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      maintenanceroleWebApi,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postRoleApprover(payload: any): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      `${maintenanceroleWebApi}/approver`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function put(id: number, payload: any): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(
      `${maintenanceroleWebApi}/${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putRoleApprover(id: number, payload: any): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(
      `${maintenanceroleWebApi}/approver/${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function deleteRoleApproverById(id: number): Promise<any> {
  try {
    if (id) {
      const { data } = await httpClient.get<boolean>(
        `${maintenanceroleWebApi}/approver/delete/${id}`
      );
      return data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const maintenancerole = {
  getRoleApproversByRoleId,
  postRoleApprover,
  putRoleApprover,
  getSystemTypeAndCategoryBySystemAppId,
  deleteRoleApproverById,
  get,
  post,
  put,
};
